import React from "react";

type Props = {
  buttonText: React.ReactNode,
  field?: string,
  label?: string,
  placeholder?: string,
  submitModifiers?: string,
  onChange: (e: any) => void,
  value: string
}

const SearchInput : React.FC<Props> = ({ buttonText, field, label, placeholder, submitModifiers, onChange, value }) => {
  return (
    <div className={`form-search-wrapper`}>
      <label className="text-input__label form-label label-input visually-hidden" htmlFor={field}>
        {label}
      </label>
      <input
        aria-label="Search For The Section You're Looking For"
        className="search-input"
        id={field}
        name="q"
        placeholder={placeholder}
        type="search"
        onChange={onChange}
        value={value}
        autoComplete="off"
      />
      <button aria-label="Search" className={`search-submit ${submitModifiers}`}>
        {buttonText}
      </button>
    </div>
  );
};

SearchInput.defaultProps = {
  buttonText: "Search",
  field: "section-search",
  label: "Search",
  placeholder: "1-1-100",
  submitModifiers: "button primary default"
};

export default SearchInput;
